<template>
  <Transition name="fade">
    <section :class="['modal', { '--visible': isOpen }]">
      <button class="modal__button --close" @click="closeModal">
        <Icon id="hamburger-opened" />
      </button>
      <div class="modal__image-container" ref="container">
        <Transition name="fade" mode="out-in">
          <Image
            v-if="images.length"
            :source="images[currentImage]"
            class="modal__image"
            :key="`images-modal-image${currentImage}`"
          />
        </Transition>
        <button class="modal__button --image --left" @click="swipeLeft">
          <Icon id="horizontal-arrow" />
        </button>
        <button class="modal__button --image" @click="swipeRight">
          <Icon id="horizontal-arrow" />
        </button>
      </div>
      <div class="modal__bottom">
        <div class="modal__preview">
          <div class="modal__preview-list">
            <Image
              v-for="(image, imageKey) in images"
              :key="imageKey"
              :source="image"
              :class="['modal__preview-image', { '--active': imageKey === currentImage }]"
              @click="changeCurrentImage(imageKey)"
            />
          </div>
        </div>
        <button class="modal__button --bottom" @click="swipeRight">
          <Icon id="horizontal-arrow" />
        </button>
      </div>
    </section>
  </Transition>
</template>

<script>
import Icon from '@/components/global/Icon.vue'
import Image from '@/components/global/Image.vue'

export default {
  name: 'ImagesModal',
  data() {
    return {
      currentImage: 0,
      isOpen: false,
      swiperInitialPosition: 0,
    }
  },
  components: { Image, Icon },
  props: {
    images: {
      type: Array,
      required: true,
    },
  },
  methods: {
    changeCurrentImage(newIndex) {
      this.currentImage = newIndex
    },
    closeModal() {
      this.isOpen = false
      this.currentImage = 0
    },
    swipeLeft() {
      const newIndex = this.currentImage - 1 >= 0 ? this.currentImage - 1 : this.images.length - 1
      this.changeCurrentImage(newIndex)
    },
    swipeRight() {
      const newIndex = this.currentImage + 1 < this.images.length ? this.currentImage + 1 : 0
      this.changeCurrentImage(newIndex)
    },
  },
  watch: {
    images() {
      this.isOpen = true
    },
    isOpen() {
      if (this.isOpen && !document.body.classList.contains('--lock')) {
        document.body.classList.add('--lock')
      } else if (!this.isOpen && document.body.classList.contains('--lock')) {
        document.body.classList.remove('--lock')
      }
    },
  },
  mounted() {
    this.$refs.container.addEventListener('touchstart', (event) => {
      this.swiperInitialPosition = event.touches[0].clientX
    })
    this.$refs.container.addEventListener('touchend', (event) => {
      if (this.swiperInitialPosition > event.changedTouches[0].clientX) {
        this.swipeRight()
      } else {
        this.swipeLeft()
      }
    })
  },
}
</script>
